import { useSelfDriveSelector } from '@/domain/prices/transports/hooks';

export const SelfDriveSelector = () => {
  useSelfDriveSelector();
  return null;
};
